var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._b({staticClass:"ui-svg-inline",attrs:{"width":_vm.size,"height":_vm.size,"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}},'svg',_vm.$attrs,false),[_c('path',{attrs:{"d":"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }